import { Module } from '../Module';
import { ScheduleDaysOfTheWeek } from '../../schedule/types/ISchedule';

interface IDaysPickerScope extends ng.IScope {
  dayNames: string[];
  toggleDay: (day: string) => void;
  isSelected: (day: string) => boolean;
}

Module.instance().directive('tbDaysPicker', <any[]>[
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'daysPicker.html',
      require: 'ngModel',
      scope: {
      },
      link: (scope: IDaysPickerScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {

        scope.dayNames = [
          ScheduleDaysOfTheWeek.Sun,
          ScheduleDaysOfTheWeek.Mon,
          ScheduleDaysOfTheWeek.Tue,
          ScheduleDaysOfTheWeek.Wed,
          ScheduleDaysOfTheWeek.Thu,
          ScheduleDaysOfTheWeek.Fri,
          ScheduleDaysOfTheWeek.Sat
        ];

        let selectedDays: string[] = [];

        scope.toggleDay = (day: string) => {

          const index = selectedDays.indexOf(day);
          if (index >= 0) {
            selectedDays.splice(index, 1);
          } else {
            selectedDays.push(day);
          }

          ctrl.$setViewValue(selectedDays);
          ctrl.$render();
        };

        scope.isSelected = (day: string) => selectedDays.indexOf(day) >= 0;

        function anySelected() {
          return selectedDays.length > 0;
        }

        ctrl.$render = () => {
          selectedDays = ctrl.$viewValue || [];
          ctrl.$setValidity('daysPicker', anySelected());
        };

      }
    };
  }
]);
